import React from "react";
import classNames from "classnames";
import styles from "./unit-pill.module.scss";

const UnitPill = ({ value, unit, className, style }) => {
  return (
    <div className={classNames(styles.container, className)} style={style}>
      <span className={styles.value}>{value}</span>
      {unit && <span className={styles.unit}>{unit}</span>}
    </div>
  );
};

export default UnitPill;
